let config = {
  ajaxBaseUrl: process.env.VUE_APP_YTVIP_HOST,
  wxApiBaseUrl: process.env.VUE_APP_WECHAT_SHARE_HOST, 
  // APPID: process.env.VUE_APP_WX_APPID,
}

export default config
